import React, { useContext, useEffect, useState, createContext } from "react";

export const LanguageContext = createContext();

export const useLanguage = () => {
  return useContext(LanguageContext);
};

// Traduções
const translations = {
  pt: {
    // Login/Demo page
    "login.subtitle": "Escolha o seu certificado digital",
    "login.button.certificate": "Logar com certificado digital",
    "login.button.login": "Logar",
    "login.button.refresh": "Recarregar Certificados",
    "login.button.cancel": "Cancelar",
    "login.label.certificate": "Escolha um certificado",
    "login.loading": "Por favor, aguarde...",
    "login.phone": "(67) 4042-7490",
    "login.or": "ou",
    "login.language.select": "Selecione o idioma",
    "login.usuario": "Usuário",
    "login.senha": "Senha",
    "login.error.invalid_credentials": "Usuário ou senha inválidos",
    "login.error.invalid_certificate": "O certificado não é válido: ",
    "login.error.pki":
      "Erro ao conectar no servidor Web Pki. Tente novamente em alguns instantes.",

    //Menu
    "menu.notas": "Notas",
    "menu.cadastros": "Cadastros",
    "menu.consultas": "Consultas",
    "menu.consulta_tributaria": "Consulta Tributária",
    "menu.produtos": "Produtos",
    "menu.lista_produtos": "Lista de Produtos",
    "menu.tributacao": "Tributação",

    //Pesquisa
    "menu.datainicial": "Data inicial",
    "menu.datafinal": "Data final",
    "menu.pesquisar": "Pesquisar",
    "menu.baixar_xmls": "Baixar XMLs",
    "menu.baixar_xmls_title": "Baixar os XMLs das notas selecionadas",

    // Common
    "common.portal_do_contador": "Portal do Contador",
    "common.attention": "Atenção",
    "common.error": "Erro",
    "common.success": "Sucesso",
    "common.sair": "Sair",
    "common.nenhuma_nota_selecionada": "Nenhuma nota selecionada.",
    "common.selecione_alguma":
      "Selecione alguma(s) antes de executar esta ação",
  },
  es: {
    // Login/Demo page
    "login.subtitle": "Elija su certificado digital",
    "login.button.certificate": "Iniciar sesión con certificado digital",
    "login.button.login": "Iniciar sesión",
    "login.button.refresh": "Recargar Certificados",
    "login.button.cancel": "Cancelar",
    "login.label.certificate": "Elija un certificado",
    "login.loading": "Por favor, espere...",
    "login.phone": "+55 67 4042-7490",
    "login.or": "o",
    "login.language.select": "Seleccione el idioma",
    "login.usuario": "Usuario",
    "login.senha": "Contraseña",
    "login.error.invalid_credentials": "Usuario o contraseña inválidos",
    "login.error.invalid_certificate": "El certificado no es válido: ",
    "login.error.pki":
      "Error al conectar con el servidor Web Pki. Inténtelo de nuevo en unos momentos.",

    //Menu
    "menu.notas": "Facturación Electrónica",
    "menu.cadastros": "Registros",
    "menu.consultas": "Consultas",
    "menu.consulta_tributaria": "Consulta Tributaria",
    "menu.produtos": "Productos",
    "menu.lista_produtos": "Lista de Productos",
    "menu.tributacao": "Tributación",

    //Pesquisa
    "menu.datainicial": "Fecha inicial",
    "menu.datafinal": "Fecha final",
    "menu.pesquisar": "Buscar",
    "menu.baixar_xmls": "Descargar XMLs",
    "menu.baixar_xmls_title":
      "Descargar los XMLs de las facturas seleccionadas",

    // Common
    "common.portal_do_contador": "Portal del Contador",
    "common.attention": "Atención",
    "common.error": "Error",
    "common.success": "Éxito",
    "common.sair": "Salir",
    "common.nenhuma_nota_selecionada": "Ningún documento seleccionado.",
    "common.selecione_alguma":
      "Seleccione uno o más antes de realizar esta acción.",
  },
};

// Detecta idioma do navegador
const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.userLanguage;
  // Se o navegador está em espanhol, retorna 'es', senão 'pt'
  return browserLang.toLowerCase().startsWith("es") ? "es" : "pt";
};

export const LanguageProvider = ({ children }) => {
  // Tenta recuperar idioma salvo, se não houver, detecta do navegador
  const [language, setLanguageState] = useState(() => {
    const savedLanguage = localStorage.getItem("language");
    return savedLanguage || detectBrowserLanguage();
  });

  // Salva idioma no localStorage sempre que mudar
  useEffect(() => {
    localStorage.setItem("language", language);
  }, [language]);

  // Função para trocar idioma
  const setLanguage = (lang) => {
    if (lang === "pt" || lang === "es") {
      setLanguageState(lang);
    }
  };

  // Função de tradução
  const t = (key) => {
    return translations[language]?.[key] || key;
  };

  // Retorna idioma atual e se é espanhol
  const isSpanish = language === "es";
  const isPortuguese = language === "pt";

  return (
    <LanguageContext.Provider
      value={{
        language,
        setLanguage,
        t,
        isSpanish,
        isPortuguese,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
